var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeavingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 10.0002C5.83301 7.69898 7.69849 5.8335 9.99967 5.8335C12.3009 5.8335 14.1663 7.69898 14.1663 10.0002C14.1663 12.3013 12.3009 14.1668 9.99967 14.1668C7.69849 14.1668 5.83301 12.3013 5.83301 10.0002Z",
    fill: "#647490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavingIcon);
export default __webpack_public_path__ + "static/media/leaving_icon.98022d9afd535e6b436452aa371895f0.svg";
export { ForwardRef as ReactComponent };